export default "__VITE_ASSET__ByuCe3wF__"